module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/jszip/node_modules/core-js/library/modules/_fails.js
// module id = ../../../../jszip/node_modules/core-js/library/modules/_fails.js
// module chunks = common